<template>
    <div>
        <div v-bind:class="{ 'container-fluid': true, 'location-detail': selectedLocation != null }">
            <div v-if="!location && selectedLocation == null" class="row">
                <div class="col-lg-6 location-search-container">
                    <div class="row">
                        <div class="col-12" id="main-content">
                            <h1 class="h3 location-search-container__title">{{ pageTitle }}</h1>
                        </div>
                    </div>
                    <filter-view></filter-view>
                    <div class="location-search-container__results desktop">
                        <app-results-list></app-results-list>
                    </div>
                </div>
                <div class="col-lg-6 fixed-right map-container" role="region" aria-label="map">
                    <map-view></map-view>
                </div>
            </div>
            <div v-if="location || selectedLocation != null"  class="row">
                <div class="col-lg-6 location-search-container single">
                    <results-detail-item :location="selectedLocation"
                        :unSelectLocationClick="unSelectLocationFn"></results-detail-item>
                </div>
                <div class="col-lg-6 fixed-right map-container single" role="region" aria-label="map">
                    <teaser-block v-if="selectedLocation != null && selectedLocation.teaser"></teaser-block>
                    <map-view></map-view>
                </div>
            </div>
        </div>
        <div v-if="isMobile">
            <app-results-list></app-results-list>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Filter from "./components/Filter.vue";
import Map from "./components/Map.vue";
import ResultsDetailItem from "./components/ResultsDetailItem.vue";
import ResultsList from "./components/ResultsList.vue";
import TeaserBlock from "./components/TeaserBlock.vue";
import Vue from "vue";
import VueMq from 'vue-mq';

Vue.use(VueMq, {
    breakpoints: {
        mobile: 678,
        tablet: 992,
        desktop: Infinity,
    }
});

export default {
    data() {
        return {

        }
    },
    created() {
        if (this.location) {
            this.isSpecificLocation = true;
            this.getSpecificLocation({
                id: this.location
            });
        }
    },
    mounted() {
        //if (typeof HERO_analytics_data_layer != "undefined") {
        //    var analytics = HERO_analytics_data_layer;
        //    analytics.pushDefault();
        //}

        if (typeof HERO_speedbump != "undefined") {
            setTimeout(function () {
                HERO_speedbump.init();
            }, 1000);
        }
        
        const userSearch = window.localStorage.getItem('userSearch');
        const userPayload = window.localStorage.getItem('userPayload');
        var payload = {};
        if(userPayload !== null) {
             payload = JSON.parse(userPayload);
        }
        if(userSearch === null || userSearch === 'false' || userPayload == null && !this.isSpecificLocation) {
            this.geolocateUser();
        }         
    },
    components: {
        "filter-view": Filter,
        "map-view": Map,
        "app-results-list": ResultsList,
        "results-detail-item": ResultsDetailItem,
        "teaser-block": TeaserBlock
    },
    computed: {
        isMobile: {
            get() {
                return this.$mq != 'desktop';
            }
        },
        isSpecificLocation: {
            get() {
                return this.$store.getters.isSpecificLocation;
            },
            set(value) {
                this.updateIsSpecificLocation(value);
            }
        },
        selectedLocation: {
            get() {
                return this.$store.getters.selectedLocation;
            },
            set(value) {
                this.updateSelectedLocation(value);
            }
        },
        userLocation: {
            get() {
                return this.$store.getters.userLocation;
            }
        },
    },
    methods: {
        ...mapActions(["geolocateUser", "getLocations", "getSpecificLocation", "updateIsSpecificLocation", "updateSelectedLocation"]),

        scrollToTop() {
            var target = document.getElementsByClassName("sidebar-wrapper")[0];
            scrollTo(target, 0, 300);
        },
        unSelectLocationFn() {
            this.selectedLocation = null;
            this.scrollToTop();
            if (typeof HERO_analytics_data_layer != "undefined") {
                var analytics = HERO_analytics_data_layer;
                analytics.pushDefault();
            }
        }
    },
    props: {
        pageTitle: String,
        location: String
    },
    watch: {
        userLocation(newValue) {
            if (!this.location) {
                this.getLocations(this.userLocation);
            }
        }
    }
};
</script>
